module.exports = __webpack_public_path__ + "img/cartao_visa.ae454b09.svg";